// About Images
import Service_Conservation_Img from "../srcAssets/Images/About/Gir01_punnayurkulam_landscape.webp";
import Service_Community_Img from "../srcAssets/Images/About/DwarfCow01_Landscape.webp";
import Service_Compassion_Img from "../srcAssets/Images/About/Sahiwal01_punnayurkulam_landscape.webp";
import Service_Satvik_Store_Img from "../srcAssets/Images/About/Vechur01_punnayurkulam_landscape.webp";

//Logo image
const logoImg = "Assets/Images/Logo/samskrithi-round-logo-combined.png";

// Adoption Cow Images

const AdoptionBhaginiImg =
  "Assets/Images/Engage/Adoption/Bhagini/adoption-bhagini-desktop_600.jpg";
const AdoptionBhairavImg =
  "Assets/Images/Engage/Adoption/Bhairav/Bhairav-sahilwal-desktop_600.jpg";
const AdoptionChittiImg =
  "Assets/Images/Engage/Adoption/Chitti/chitti-vechur-desktop_600.jpg";
const AdoptionMadhaviImg =
  "Assets/Images/Engage/Adoption/Madhavi/Madhavi-desktop_600.jpg";
const AdoptionRamesvarImg =
  "Assets/Images/Engage/Adoption/Ramesvar/Ramesvar-desktop_600.jpg";
const AdoptionRudraImg =
  "Assets/Images/Engage/Adoption/Rudra/adoption-rudra-desktop_600.jpg";
const AdoptionVisvaImg =
  "Assets/Images/Engage/Adoption/Viswa/Viswa-desktop_600.jpg";

// virtual Adoption Cow Images

const VAdoptionBhaginiImg =
  "Assets/Images/Engage/VirtualAdoption/Bhagini/adoption-bhagini-desktop_600.jpg";
const VAdoptionBhairavImg =
  "Assets/Images/Engage/VirtualAdoption/Bhairav/Bhairav-sahilwal-desktop_600.jpg";
const VAdoptionChittiImg =
  "Assets/Images/Engage/VirtualAdoption/Chitti/chitti-vechur-desktop_600.jpg";
const VAdoptionMadhaviImg =
  "Assets/Images/Engage/VirtualAdoption/Madhavi/Madhavi-desktop_600.jpg";
const VAdoptionRamesvarImg =
  "Assets/Images/Engage/VirtualAdoption/Ramesvar/Ramesvar-desktop_600.jpg";
const VAdoptionRudraImg =
  "Assets/Images/Engage/VirtualAdoption/Rudra/adoption-rudra-desktop_600.jpg";
const VAdoptionVisvaImg =
  "Assets/Images/Engage/VirtualAdoption/Viswa/Viswa-desktop_600.jpg";

// Our Story Images
const OurStory_Img_Desktop = "Assets/Images/OurStory/ourstory-desktop_904.jpg";
const OurStory_Img_Phone = "Assets/Images/OurStory/ourstory-phone_450.jpg";

// Video Gallery Images
const Video_Img1 =
  "Assets/Images/VideoImages/SamskrithivideoImage01-combined_220.jpg";
const Video_Img2 =
  "Assets/Images/VideoImages/SamskrithivideoImage02-combined_220.jpg";
const Video_Img3 =
  "Assets/Images/VideoImages/SamskrithivideoImage03-combined_220.jpg";
const Video_Img4 =
  "Assets/Images/VideoImages/SamskrithivideoImage04-combined_220.jpg";
const Video_Img5 =
  "Assets/Images/VideoImages/SamskrithivideoImage05-combined_220.jpg";
const Video_Img6 =
  "Assets/Images/VideoImages/SamskrithivideoImage06-combined_220.jpg";
const Video_Img7 =
  "Assets/Images/VideoImages/SamskrithivideoImage07-combined_220.jpg";
const Video_Img8 =
  "Assets/Images/VideoImages/SamskrithivideoImage08-combined_220.jpg";

//Donate images
const Donate_Img_Desktop = "Assets/Images/Engage/Donate/donate-desktop.jpeg";
const GiftMerchandise_Img_Desktop =
  "Assets/Images/Engage/GiftMerchandise/giftmerchandice-desktop.jpeg";
const DigitalVolunteer_Img_Desktop =
  "Assets/Images/Engage/DigitalVolunteer/digitalvolunteer-desktop.jpeg";

//onsite volunteer images
const Onsite_Volunteer_Img1_Desktop =
  "Assets/Images/Engage/OnsiteVolunteer/OnlineVolunteer-BuildingaCowshed-desktop.jpg";
const Onsite_Volunteer_Img1_Phone =
  "Assets/Images/Engage/OnsiteVolunteer/OnlineVolunteer-BuildingaCowshed-phone.jpg";
const Onsite_Volunteer_Img2_Desktop =
  "Assets/Images/Engage/OnsiteVolunteer/OnlineVolunteer-GreyHeronPunnayarkulam-desktop.jpg";
const Onsite_Volunteer_Img2_Phone =
  "Assets/Images/Engage/OnsiteVolunteer/OnlineVolunteer-GreyHeronPunnayarkulam-desktop.jpg";
const Onsite_Volunteer_Img3_Desktop =
  "Assets/Images/Engage/OnsiteVolunteer/OnlineVolunteer-MannalamkunniBeach-desktop.jpg";
const Onsite_Volunteer_Img3_Phone =
  "Assets/Images/Engage/OnsiteVolunteer/OnlineVolunteer-MannalamkunniBeach-phone.jpg";
const Onsite_Volunteer_Img4_Desktop =
  "Assets/Images/Engage/OnsiteVolunteer/OnlineVolunteer-PunnathurkottaElephantSanctuary-desktop.jpeg";
const Onsite_Volunteer_Img4_Phone =
  "Assets/Images/Engage/OnsiteVolunteer/OnlineVolunteer-PunnathurkottaElephantSanctuary-phone.jpg";

//Gausevak images
const Gausevak_Img1 = "Assets/Images/GauSevak/GauSevak01.png";
const Gausevak_Img2 = "Assets/Images/GauSevak/Krishnalal.jpg";

// Bodycare Images

const MilkSoapImg =
  "Assets/Images/Products/Bodycare/05._milk_soap_-_combined01_289.png";
const NeemOilImg =
  "Assets/Images/Products/Bodycare/06._neem_oil_-_combined01_80.png";
const SurabhiPanchagavyaSoapImg =
  "Assets/Images/Products/Bodycare/13._surabhi_panchgavya_soap_-_combined01_192.png";
const AloeVeraGelImg =
  "Assets/Images/Products/Bodycare/14._aloe_vera_gel_-_combined01_272.png";
const AloeVeraGelImg2 =
  "Assets/Images/Products/Bodycare/14._aloe_vera_gel_-_combined02_267.png";
const AloeVeraRoseGelImg =
  "Assets/Images/Products/Bodycare/15._aloe_vera_rose_gel_-_combined01_268.png";
const AloeVeraRoseGelImg2 =
  "Assets/Images/Products/Bodycare/15._aloe_vera_rose_gel_-_combined02_275.png";
const DishWashingPowderImg =
  "Assets/Images/Products/Bodycare/17._dish_washing_powder_-_combined01_164.png";
const HandWashLiquidImg =
  "Assets/Images/Products/Bodycare/18._hand_wash_liquid_-_combined01_81.png";
const DantManjanamImg =
  "Assets/Images/Products/Bodycare/19._dant_manjanam_-_combined01_130.png";
const ActiveCarbonDantManjanamImg =
  "Assets/Images/Products/Bodycare/20._active_carbon_dant_manjanam_-_combined01_109.png";
const BalmImg = "Assets/Images/Products/Bodycare/24._balm_-_combined01_272.png";
const MultaniOrangeFacepackImg =
  "Assets/Images/Products/Bodycare/25._multani_orange_facepack_-_combined01_158.png";
const MultaniKesarFacepackImg =
  "Assets/Images/Products/Bodycare/26._multani_kesar_facepack_-_combined01_165.png";
const BathingPowderImg =
  "Assets/Images/Products/Bodycare/28._bathing_powder_-_combined01_135.png";
const BathingPowderImg2 =
  "Assets/Images/Products/Bodycare/28._bathing_powder_-_combined02_137.png";
const DishWashCakeImg =
  "Assets/Images/Products/Bodycare/29._dish_wash_cake_-_combined01_236.png";

// Environment Images

const CowDungCakeImg1 =
  "Assets/Images/Products/Environment/03._Cow_Dung_Cake_-_combined01_225.png";
const CowDungCakeImg2 =
  "Assets/Images/Products/Environment/03._Cow_Dung_Cake_-_combined02_200.png";
const GomutraNeemPhenolImg =
  "Assets/Images/Products/Environment/16._gomutra_neem_phenol_-_combined01_81.png";

// Health Images

const KapilaGauArkaImg1 =
  "Assets/Images/Products/Health/02._Kapila_Gau_Arka_-_combined01_77.png";
const KapilaGauArkaImg2 =
  "Assets/Images/Products/Health/02._Kapila_Gau_Arka_-_combined02_300.png";
const MuscleOilImg =
  "Assets/Images/Products/Health/21._muscle_oil_-_combined01_161.png";
const BabyMassageOilImg =
  "Assets/Images/Products/Health/22._baby_massage_oil_-_combined01_83.png";
const TulsiArkImg =
  "Assets/Images/Products/Health/23._tulsi_ark_-_combined01_66.png";
const DiabetesArkImg1 =
  "Assets/Images/Products/Health/27._diabetes_arka_-_combined01_73.png";
const DiabetesArkImg2 =
  "Assets/Images/Products/Health/27._diabetes_arka_-_combined02_300.png";
const BloodPressureArkImg1 =
  "Assets/Images/Products/Health/30._blood_pressure_arka_-_combined01_77.png";
const BloodPressureArkImg2 =
  "Assets/Images/Products/Health/30._blood_pressure_arka_-_combined02_300.png";
const CowColostrumImg =
  "Assets/Images/Products/Health/31._cow_colostrum_-_combined01_200.png";
const WildcraftedChawanprashImg =
  "Assets/Images/Products/Health/32._wildcrafted_chyawanprash_-_combined01_200.png";

// Grocery Images

// Cereals Images

const BrownRiceImg1 =
  "Assets/Images/Products/Grocery/Cereals/01._brown_rice_-_combined01_225.png";
const BrownRiceImg2 =
  "Assets/Images/Products/Grocery/Cereals/01._brown_rice_-_combined02_216.png";
const WhiteRiceImg1 =
  "Assets/Images/Products/Grocery/Cereals/02._white_rice_-_combined01_139.png";
const WhiteRiceImg2 =
  "Assets/Images/Products/Grocery/Cereals/02._white_rice_-_combined02_206.png";
const RedRiceImg1 =
  "Assets/Images/Products/Grocery/Cereals/03._red_rice_-_combined01_165.png";
const RedRiceImg2 =
  "Assets/Images/Products/Grocery/Cereals/03._red_rice_-_combined02_204.png";
const WildBlackRiceImg1 =
  "Assets/Images/Products/Grocery/Cereals/04._wild_black_rice_-_combined01_150.png";
const WildBlackRiceImg2 =
  "Assets/Images/Products/Grocery/Cereals/04._wild_black_rice_-_combined02_199.png";
const BarleyPearlImg1 =
  "Assets/Images/Products/Grocery/Cereals/05._barley_pearl_-_combined01_177.png";
const BarleyPearlImg2 =
  "Assets/Images/Products/Grocery/Cereals/05._barley_pearl_-_combined02_204.png";
const BarleyFlakeImg1 =
  "Assets/Images/Products/Grocery/Cereals/06._barley_flake_-_combined01_141.png";
const BarleyFlakeImg2 =
  "Assets/Images/Products/Grocery/Cereals/06._barley_flake_-_combined02_214.png";

// Ghee Images

const GheeImg1 =
  "Assets/Images/Products/Grocery/Ghee/01._ghee_-_combined01_139.png";
const GheeImg2 =
  "Assets/Images/Products/Grocery/Ghee/01._ghee_-_combined02_200.png";

// Honey and Jaggery Images

const HoneyImg1 =
  "Assets/Images/Products/Grocery/Honey-Jaggery/04._honey_-_combined01_137.png";
const HoneyImg2 =
  "Assets/Images/Products/Grocery/Honey-Jaggery/04._honey_-_combined02_136.png";

// Masala Images

const CurryLeafPowderImg =
  "Assets/Images/Products/Grocery/Masala/10._curry_leaf_powder_-_combined01_167.png";
const RasamPowderImg1 =
  "Assets/Images/Products/Grocery/Masala/11._rassam_powder_-_combined01_137.png";
const RasamPowderImg2 =
  "Assets/Images/Products/Grocery/Masala/11._rassam_powder_-_combined02_136.png";

// Misc Images

const EdibleRoseWaterImg =
  "Assets/Images/Products/Grocery/Misc/12._edible_rose_water_-_original01_64.png";

// Oils Images

const GhaniOilImg =
  "Assets/Images/Products/Grocery/Oils/07._ghani_oil_-_original01_83.png";
const CoconutOilImg1 =
  "Assets/Images/Products/Grocery/Oils/08._coconut_oil_-_original01_79.png";
const CoconutOilImg2 =
  "Assets/Images/Products/Grocery/Oils/08._coconut_oil_-_original02_80.png";
const CastorOilImg =
  "Assets/Images/Products/Grocery/Oils/09._castor_oil_-_original01_82.png";

// Pulses Images

const MasoorImg =
  "Assets/Images/Products/Grocery/Pulses/01._Masoor_-_combined01_200.png";
const ArharImg =
  "Assets/Images/Products/Grocery/Pulses/02._Arhar_-_combined01_200.png";
const SabitMasoorPeeledImg =
  "Assets/Images/Products/Grocery/Pulses/03._Sabit_Masoor_Peeled_-_combined01_200.png";
const SabitMasoorImg =
  "Assets/Images/Products/Grocery/Pulses/04._Sabit_Masoor_-_combined01_200.png";
const KabuliChanaImg =
  "Assets/Images/Products/Grocery/Pulses/05._Kabuli_Chana_-_combined01_200.png";
const MatarImg =
  "Assets/Images/Products/Grocery/Pulses/06._Matar_-_combined01_200.png";
const ChanaImg =
  "Assets/Images/Products/Grocery/Pulses/07._Chana_-_combined01_200.png";
const MoongImg =
  "Assets/Images/Products/Grocery/Pulses/08._Moong_-_combined01_200.png";

// Category Images
const Categories_Img1 =
  "Assets/Images/Categories/01.Conservation/Compassion-combined_140.png";
const Categories_Img2 =
  "Assets/Images/Categories/02.Community/Community-combined_140.png";
const Categories_Img3 =
  "Assets/Images/Categories/03.Compassion/Compassion-combined_140.png";
const Categories_Img4 =
  "Assets/Images/Categories/04.SatvikStore/Compassion-combined_140.png";

//Person Avatar
const personAvatar = "Assets/Images/Testimonials/avatar.png";

let WebData = {
  personAvatar: personAvatar,
  Logo: {
    image: logoImg,
  },
  contact: {
    mail: "samskrithigoshala@gmail.com",
    whatsapp: "9544010123",
    phone: "9495551978",
    telegram: "",
    dayArray: [
      ["closed"],
      ["08", "00", "16", "00"],
      ["08", "00", "16", "00"],
      ["08", "00", "16", "00"],
      ["08", "00", "18", "00"],
      ["10", "00", "17", "00"],
      ["11", "00", "17", "00"],
    ],
    address:
      "Samskrithi Gaushala, Kanjekatt House, Attupuram, Punnayurkulam, Guruvayur, Thrissur, Kerala, India 679561",
  },
  socialLink: {
    facebook: "https://www.facebook.com/samskrithi.goshala.16",
    instagram: "https://www.facebook.com/samskrithi.goshala.16",
  },
  navbar: {
    options: [
      {
        title: "About",
        link: "about",
      },
      {
        title: "Service",
        link: "services",
      },
      {
        title: "Engage",
        link: "engage",
      },
      {
        title: "Contact",
        link: "contact",
      },
    ],
  },
  about: {
    ourStory: {
      images: [
        {
          imageUrl: OurStory_Img_Desktop,
        },
        {
          imageUrl: OurStory_Img_Phone,
        },
      ],
    },
  },
  skillsList: [
    {
      name: "Student",
    },
    {
      name: "Coding",
    },
    {
      name: "Engineering",
    },
    {
      name: "Dairy",
    },
    {
      name: "Farming",
    },
    {
      name: "Graphics Design",
    },
    {
      name: "Legal",
    },
    {
      name: "Marketing",
    },
    {
      name: "Veterinary",
    },
    {
      name: "Video Editing",
    },
    {
      name: "Other",
    },
  ],
  categories: {
    desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. In obcaecati impedit laudantium, enim distinctio saepe.",
    items: [
      {
        imageUrl: Categories_Img1,
        categoryName: "Conservation",
        desc: `Operation Flood was launched in 1970. It led to the "White Revolution". The revolution put India on the path of substantial increase in milk yield per cow - the time to maturity of heifers declined by almost 50%, Oxytocin became a substitute for calf's presence leading to an increase in space use efficiency. This was further bolstered by the emergence of the dairy antibiotic industry. The 'tablets' would keep the new breed of cows disease-free in the Indian climes even as the space available to them decreased further. The only problem was for all the milk that was flowing, the Indian traditional fodder simply did not have adequate nutrition density. The suppliers of imported breeds had a ready solution in the form of scientifically designed feeds. The feeds altered the metabolism and led to attendant problems of higher birth mortality rates, heart attacks and other diseases, some of which was managed with additional antibiotics. The rest was ignored as the expected profits would more than cover it. Initially the farmers and the people were both reluctant to adopt foreign breeds. However with the weight of the drug, feed and breed import lobby and the socialist rhetoric of keeping prices low the use of high yield breeds started to rise. The government began imposing financial penalties on farmers who maintained indigenous breeds. If foreign breeds could not be supplied, bulls were and the indigenous pool of cows were simply bred out. There is no free lunch. Operation Flood came with great, non-monetized, negative externalities. High-yielding cows require 4x the amount of fodder needed by indigenous breeds and they release 10x the amount of methane (methane's global warming potential is 25x of carbon dioxide). Multiply that by 200 million cattle and it is easy to see how Operation Flood is bad for the environment. The antibiotics pumped into the cows flowed into the human via "cheap" milk causing the emergence of antibiotic resistance and a decline in the natural immune capacity of the human body. These effects of Operation Flood are not much talked about in public discourse but easily understood. The effects of loss of genetic diversity are harder to grasp. Operation flood led to disappearance of about 40 native cattle breeds and has pushed another 12 to near extinction. That is about half of the genetic diversity. It also dried out research funds for breed diversity conservation, gene mapping, pharmacogenetic studies and ancient traditional knowledge of cattle rearing or preparing milk derivatives with medicinal properties. Intra-species genetic diversity influences population persistence and evolutionary potential. Phylogeographic analysis can unravel a detailed evolutionary history of a species and how this history contributes to the understanding of the past environment and climactic events in the region. Ongoing genetic diversity loss in an animal so intimately linked with human history leads not only to loss of biodiversity but also to the loss of a significant information regarding past anthropological events. At Samskrithi Goshala we are conscious of our larger responsibility in conserving genetic breed diversity of native cattle.  Their milk is far nutritious though yield is just about 20%. They are particularly environmentally friendly. Derivatives made from milk of indigenous cattle breeds have superior pharmological properties.  Their cost of upkeep is far less than that for high-yield breeds. As they are suited to the local environment and not forced into unnatural milk production cycles, they need comparatively far less antibiotic administrations.  We are bringing back knowledge on rearing indigenous breeds. We started with one in 2010 and we now are up to 85. Come <a href="#locate">visit our family</a> some time! If you like what we do then please <a href="#">click here</a> to contribute.`,
        images: Service_Conservation_Img,
      },
      {
        imageUrl: Categories_Img2,
        categoryName: "Community",
        desc: "It is only by engaging people in the cause can we build compassionate communities. We encourage people to adopt, to neuter their bulls and prevent them from breeding. We are growing our ecosystem support for volunteers to find easy access to opportunities to make a difference through the time they can spare, financial donations and spread awareness in their network. Check more here. <br /> <b>Raising Awareness:</b> Making people aware of the negative externalities of the dairy industry, the beneficial impact on human health of traditional dairy practices and gene diversity maintenance. We shine a light on the interconnectedness of the dairy and slaughter and how they cause abandonment of male calves. <br /><b>Engaging Volunteers:</b> Volunteers are an integral part of Samskrithi Goshala. In 2021 we launched a digital volunteer program that allows one to lend a helping hand from anywhere in the world. Volunteers work in every facet of our organization, from intake and adoption counseling to humane education and community outreach. Because of them, we can expand our care to more cows than we ever thought of before. Click here to join our volunteer program. Put compassion into action! <br /><b>Proactive Outreach:</b> It is not enough to talk about the plight of dairy cows or why one should keep indigenous breeds. It is essential to get the information directly to under-informed communities that are the source of overpopulation and abandonment. <br />Through our community outreach component, we go door-to-door, bringing community members information on neutering, optimal diet, Ayurvedic ways of nursing the sick, traditional methods of making value-added products from milk, dung and cow urine and the importance of rearing local breeds. <br /><b>Conscious Action:</b> By spreading the word about we are spurring people to take action when it comes to animal welfare. <br />That means a greater inclination to make the choice to adopt an animal rather than buy from a breeder or, simply adopt virtually if they have limited space. It means a greater inclination to choose low cost methods for keeping old animals and making value-added products from their waste instead of abandoning them or dispatching them to slaughter. It means people become advocates, spreading the word about the work we do to the people they know as well. <br /><b>Humane Education:</b> Children not only have a natural affinity for compassion but they also are our future animal advocates. Children are not only a frequent source of information for their families, but they will be the decision-makers of the future. <br /> Arming them with knowledge about human health, environmental and conservation impact of established methods of industrial dairy farming  and how they can help advances the mission to the next generation.",
        images: Service_Community_Img,
      },
      {
        imageUrl: Categories_Img3,
        categoryName: "Compassion",
        desc: "At Samskrithi Goshala we take immense pleasure in serving our cattle. Out of the family of 85 we have 19 female calves and 28 males. The old are just as much a part of our home as the young calves are cared for. We milk our cows, attend to their food, massage the newborns and those who need medical attention. We never inject them with Oxytocin and keep them away from antibiotics unless really required. The calves get their full share of milk before we extract the excess. Studies show that happy cows yield healthier milk, devoid of toxins that are often released under stress when milch cows kept in confined, unclean surroundings or with calves separated from their mothers. Where possible, we have saved old or injured cows from slaughter but that is something we would like to do more with a little help from you. ",
        images: Service_Compassion_Img,
      },
      {
        imageUrl: Categories_Img4,
        categoryName: "Satvik Store",
        desc: `The primary mission of Samskrithi Goshala is to support breed diversity conservation efforts, practice compassion and communicate by example. As our family grew demands on sustainability became stronger. In 2016 we added milk derivatives and cow waste products to our organic agricultural output. Not just that our cows are kept antibiotic and other artificial hormone free, we use only cow urine and dung derived and vermicompost fertilizers in our farms. We grow and pack our own cereals and pulses, we make our own chyavanprash, ghee in line with traditional perpetration methods. They are expensive but pure. They keep us healthy. We would like you to try some too! Check out our <a href="#productsSection")}>Satvik Organics</a>store. It is a small one, but we are sure you will find something for your kitchen, bathroom or yard garden.`,
        images: Service_Satvik_Store_Img,
      },
    ],
  },
  donateImg: Donate_Img_Desktop,
  giftMerchandiseImg: GiftMerchandise_Img_Desktop,
  digitalVolunteerImg: DigitalVolunteer_Img_Desktop,
  onsiteVolunteer: {
    items: [
      {
        desktopImg: Onsite_Volunteer_Img1_Desktop,
        phoneImg: Onsite_Volunteer_Img1_Phone,
        thumb: "Building a Cowshed",
      },
      {
        desktopImg: Onsite_Volunteer_Img2_Desktop,
        phoneImg: Onsite_Volunteer_Img2_Phone,
        thumb: "Grey Heron Punnayarkulam",
      },
      {
        desktopImg: Onsite_Volunteer_Img3_Desktop,
        phoneImg: Onsite_Volunteer_Img3_Phone,
        thumb: "Mannalakunni Beach",
      },
      {
        desktopImg: Onsite_Volunteer_Img4_Desktop,
        phoneImg: Onsite_Volunteer_Img4_Phone,
        thumb: "Punnathurkotta Elephant Sanctuary",
      },
    ],
  },
  adoptionCows: {
    names: [
      {
        name: "Bhagini",
        image: AdoptionBhaginiImg,
        age: 5,
        breed: "Sahiwal",
        sex: "M",
      },
      {
        name: "Bhairav",
        image: AdoptionBhairavImg,
        age: 6,
        breed: "Gir",
        sex: "M",
      },
      {
        name: "Chitti",
        breed: "Vilvaadri",
        age: 7,
        image: AdoptionChittiImg,
        sex: "F",
      },
      {
        name: "Madhavi",
        image: AdoptionMadhaviImg,
        age: 10,
        breed: "Vechoor",
        sex: "M",
      },
      {
        name: "Ramesvar",
        image: AdoptionRamesvarImg,
        age: 11,
        breed: "Kazarkode",
        sex: "F",
      },
      {
        name: "Rudra",
        image: AdoptionRudraImg,
        age: 8,
        breed: "Vadakara",
        sex: "F",
      },
      {
        name: "Viswa",
        image: AdoptionVisvaImg,
        age: 9,
        breed: "Vilvaadri",
        sex: "F",
      },
    ],
  },
  vAdoptionCows: {
    names: [
      {
        name: "Bhagini",
        image: VAdoptionBhaginiImg,
        age: 5,
        breed: "Sahiwal",
        sex: "M",
      },
      {
        name: "Bhairav",
        image: VAdoptionBhairavImg,
        age: 6,
        breed: "Gir",
        sex: "M",
      },
      {
        name: "Chitti",
        breed: "Vilvaadri",
        age: 7,
        image: VAdoptionChittiImg,
        sex: "F",
      },
      {
        name: "Madhavi",
        image: VAdoptionMadhaviImg,
        age: 10,
        breed: "Vechoor",
        sex: "M",
      },
      {
        name: "Ramesvar",
        image: VAdoptionRamesvarImg,
        age: 11,
        breed: "Kazarkode",
        sex: "F",
      },
      {
        name: "Rudra",
        image: VAdoptionRudraImg,
        age: 8,
        breed: "Vadakara",
        sex: "F",
      },
      {
        name: "Viswa",
        image: VAdoptionVisvaImg,
        age: 9,
        breed: "Vilvaadri",
        sex: "F",
      },
    ],
  },
  videoGallery: [
    {
      videoUrl: "https://www.youtube.com/embed/Qpq-wV6w11A?autoplay=1",
      videoThumbnail: Video_Img1,
      videoDesc: "Punganur cow gives 4-5 lts of high fat milk daily",
    },
    {
      videoUrl: "https://www.youtube.com/embed/lcBeJKEreoY?autoplay=1",
      videoThumbnail: Video_Img2,
      videoDesc: "Milking a cow by hand, by engineering student",
    },
    {
      videoUrl: "https://www.youtube.com/embed/64Zm0VeFuEg?autoplay=1",
      videoThumbnail: Video_Img3,
      videoDesc: "Manjunath, the bull rescued from slaughter",
    },
    {
      videoUrl: "https://www.youtube.com/embed/R_tpRr8sbSM?autoplay=1",
      videoThumbnail: Video_Img4,
      videoDesc: "Bleeding calf, unable to eat, rescued by agency",
    },
    {
      videoUrl: "https://www.youtube.com/embed/u6xyn7826d8?autoplay=1",
      videoThumbnail: Video_Img5,
      videoDesc: "Rescue of Gaumata and baby cow in Noida, India",
    },
    {
      videoUrl: "https://www.youtube.com/embed/Rh-LsaoNHoY?autoplay=1",
      videoThumbnail: Video_Img6,
      videoDesc: "Injured, attacked Gaumata and Nandi Baba rescued",
    },
    {
      videoUrl: "https://www.youtube.com/embed/1_SMToxDxrM?autoplay=1",
      videoThumbnail: Video_Img7,
      videoDesc: "Smallest cow in the world: Punganur",
    },
    {
      videoUrl: "https://www.youtube.com/embed/Rh-LsaoNHoY?autoplay=1",
      videoThumbnail: Video_Img8,
      videoDesc: "Injured, attacked Gaumata and Nandi Baba rescued",
    },
  ],

  products: [
    // Bodycare Category
    {
      id: 0,
      name: "Milk Soap",
      category: "bodyCare",
      imageUrl1: MilkSoapImg,
      images: [
        {
          imageUrl: MilkSoapImg,
          alt: "Milk Soap",
        },
        {
          imageUrl: MilkSoapImg,
          alt: "Milk Soap",
        },
        {
          imageUrl: MilkSoapImg,
          alt: "Milk Soap",
        },
      ],
      price: [
        {
          name: "0",
          value: "150",
          quantity: "100 ml",
        },
        {
          name: "1",
          value: "270",
          quantity: "200 ml",
        },
        {
          name: "2",
          value: "500",
          quantity: "400 ml",
        },
        {
          name: "3",
          value: "950",
          quantity: "700 ml",
        },
        {
          name: "4",
          value: "1300",
          quantity: "1 L",
        },
      ],
    },
    {
      id: 1,
      name: "Neem Oil",
      category: "bodyCare",
      imageUrl1: NeemOilImg,
      images: [
        {
          imageUrl: NeemOilImg,
          alt: "Neem Oil",
        },
        {
          imageUrl: NeemOilImg,
          alt: "Neem Oil",
        },
        {
          imageUrl: NeemOilImg,
          alt: "Neem Oil",
        },
      ],
      price: [
        {
          name: "2",
          value: "50",
          quantity: "10 pack",
        },
        {
          name: "3",
          value: "80",
          quantity: "20 pack",
        },
      ],
    },
    {
      id: 2,
      name: "Surabhi Panchagavya Soap",
      category: "bodyCare",
      imageUrl1: SurabhiPanchagavyaSoapImg,
      images: [
        {
          imageUrl: SurabhiPanchagavyaSoapImg,
          alt: "Surabhi Panchagavya",
        },
        {
          imageUrl: SurabhiPanchagavyaSoapImg,
          alt: "Surabhi Panchagavya",
        },
        {
          imageUrl: SurabhiPanchagavyaSoapImg,
          alt: "Surabhi Panchagavya",
        },
      ],
      price: [
        {
          name: "4",
          value: "30",
          quantity: "small pack",
        },
        {
          name: "5",
          value: "50",
          quantity: "large pack",
        },
      ],
    },
    {
      id: 3,
      name: "Aloe Vera Gel",
      category: "bodyCare",
      imageUrl1: AloeVeraGelImg,
      imageUrl2: AloeVeraGelImg2,
      images: [
        {
          imageUrl: AloeVeraGelImg,
          alt: "Aloe Vera",
        },
        {
          imageUrl: AloeVeraGelImg2,
          alt: "Aloe Vera",
        },
        {
          imageUrl: AloeVeraGelImg2,
          alt: "Aloe Vera",
        },
      ],
      price: [
        {
          name: "4",
          value: "30",
          quantity: "small pack",
        },
        {
          name: "5",
          value: "50",
          quantity: "large pack",
        },
      ],
    },
    {
      id: 4,
      name: "Aloe Vera Rose Gel",
      category: "bodyCare",
      imageUrl1: AloeVeraRoseGelImg,
      imageUrl2: AloeVeraRoseGelImg2,
      images: [
        {
          imageUrl: AloeVeraRoseGelImg,
          alt: "Aloe Vera Rose",
        },
        {
          imageUrl: AloeVeraRoseGelImg2,
          alt: "Aloe Vera Rose",
        },
        {
          imageUrl: AloeVeraRoseGelImg2,
          alt: "Aloe Vera Rose",
        },
      ],
      price: [
        {
          name: "4",
          value: "30",
          quantity: "small pack",
        },
        {
          name: "5",
          value: "50",
          quantity: "large pack",
        },
      ],
    },
    {
      id: 5,
      name: "Dish Washing Powder",
      category: "bodyCare",
      imageUrl1: DishWashingPowderImg,
      images: [
        {
          imageUrl: DishWashingPowderImg,
          alt: "Dish Wash",
        },
        {
          imageUrl: DishWashingPowderImg,
          alt: "Dish Wash",
        },
        {
          imageUrl: DishWashingPowderImg,
          alt: "Dish Wash",
        },
      ],
      price: [
        {
          name: "4",
          value: "30",
          quantity: "small pack",
        },
        {
          name: "5",
          value: "50",
          quantity: "large pack",
        },
      ],
    },
    {
      id: 6,
      name: "Hand Wash Liquid",
      category: "bodyCare",
      imageUrl1: HandWashLiquidImg,
      images: [
        {
          imageUrl: HandWashLiquidImg,
          alt: "Hand Wash",
        },
        {
          imageUrl: HandWashLiquidImg,
          alt: "Hand Wash",
        },
        {
          imageUrl: HandWashLiquidImg,
          alt: "Hand Wash",
        },
      ],
      price: [
        {
          name: "4",
          value: "30",
          quantity: "small pack",
        },
        {
          name: "5",
          value: "50",
          quantity: "large pack",
        },
      ],
    },
    {
      id: 7,
      name: "Dant Manjanam",
      category: "bodyCare",
      imageUrl1: DantManjanamImg,
      images: [
        {
          imageUrl: DantManjanamImg,
          alt: "Dant Manjanam",
        },
        {
          imageUrl: DantManjanamImg,
          alt: "Dant Manjanam",
        },
        {
          imageUrl: DantManjanamImg,
          alt: "Dant Manjanam",
        },
      ],
      price: [
        {
          name: "4",
          value: "30",
          quantity: "small pack",
        },
        {
          name: "5",
          value: "50",
          quantity: "large pack",
        },
      ],
    },
    {
      id: 8,
      name: "Active Carbon Dant Manjanam",
      category: "bodyCare",
      imageUrl1: ActiveCarbonDantManjanamImg,
      images: [
        {
          imageUrl: ActiveCarbonDantManjanamImg,
          alt: "Active Carbon Dant Manjanam",
        },
        {
          imageUrl: ActiveCarbonDantManjanamImg,
          alt: "Active Carbon Dant Manjanam",
        },
        {
          imageUrl: ActiveCarbonDantManjanamImg,
          alt: "Active Carbon Dant Manjanam",
        },
      ],
      price: [
        {
          name: "4",
          value: "30",
          quantity: "small pack",
        },
        {
          name: "5",
          value: "50",
          quantity: "large pack",
        },
      ],
    },
    {
      id: 9,
      name: "Balm",
      category: "bodyCare",
      imageUrl1: BalmImg,
      images: [
        {
          imageUrl: BalmImg,
          alt: "Balm",
        },
        {
          imageUrl: BalmImg,
          alt: "Balm",
        },
        {
          imageUrl: BalmImg,
          alt: "Balm",
        },
      ],
      price: [
        {
          name: "4",
          value: "30",
          quantity: "small pack",
        },
        {
          name: "5",
          value: "50",
          quantity: "large pack",
        },
      ],
    },
    {
      id: 10,
      name: "Multani Orange Facepack",
      category: "bodyCare",
      imageUrl1: MultaniOrangeFacepackImg,
      images: [
        {
          imageUrl: MultaniOrangeFacepackImg,
          alt: "Multani Orange",
        },
        {
          imageUrl: MultaniOrangeFacepackImg,
          alt: "Multani Orange",
        },
        {
          imageUrl: MultaniOrangeFacepackImg,
          alt: "Multani Orange",
        },
      ],
      price: [
        {
          name: "4",
          value: "30",
          quantity: "small pack",
        },
        {
          name: "5",
          value: "50",
          quantity: "large pack",
        },
      ],
    },
    {
      id: 11,
      name: "Multani Kesar Facepack",
      category: "bodyCare",
      imageUrl1: MultaniKesarFacepackImg,
      images: [
        {
          imageUrl: MultaniKesarFacepackImg,
          alt: "Multani Kesar",
        },
        {
          imageUrl: MultaniKesarFacepackImg,
          alt: "Multani Kesar",
        },
        {
          imageUrl: MultaniKesarFacepackImg,
          alt: "Multani Kesar",
        },
      ],
      price: [
        {
          name: "4",
          value: "30",
          quantity: "small pack",
        },
        {
          name: "5",
          value: "50",
          quantity: "large pack",
        },
      ],
    },
    {
      id: 12,
      name: "Bathing Powder",
      category: "bodyCare",
      imageUrl1: BathingPowderImg,
      imageUrl2: BathingPowderImg2,
      images: [
        {
          imageUrl: BathingPowderImg,
          alt: "Bathing Powder",
        },
        {
          imageUrl: BathingPowderImg2,
          alt: "Bathing Powder",
        },
        {
          imageUrl: BathingPowderImg2,
          alt: "Bathing Powder",
        },
      ],
      price: [
        {
          name: "4",
          value: "30",
          quantity: "small pack",
        },
        {
          name: "5",
          value: "50",
          quantity: "large pack",
        },
      ],
    },
    {
      id: 13,
      name: "Dish Wash Cake",
      category: "bodyCare",
      imageUrl1: DishWashCakeImg,
      images: [
        {
          imageUrl: DishWashCakeImg,
          alt: "Dish Wash",
        },
        {
          imageUrl: DishWashCakeImg,
          alt: "Dish Wash",
        },
        {
          imageUrl: DishWashCakeImg,
          alt: "Dish Wash",
        },
      ],
      price: [
        {
          name: "4",
          value: "30",
          quantity: "small pack",
        },
        {
          name: "5",
          value: "50",
          quantity: "large pack",
        },
      ],
    },

    // Environment Category
    {
      id: 14,
      name: "Cow Dung Cake",
      category: "environment",
      imageUrl1: CowDungCakeImg1,
      imageUrl2: CowDungCakeImg2,
      images: [
        {
          imageUrl: CowDungCakeImg1,
          alt: "Cow Dung Cake",
        },
        {
          imageUrl: CowDungCakeImg2,
          alt: "Cow Dung Cake",
        },
        {
          imageUrl: CowDungCakeImg2,
          alt: "Cow Dung Cake",
        },
      ],
      price: [
        {
          name: "6",
          value: "30",
          quantity: "100 gm piece",
        },
        {
          name: "7",
          value: "50",
          quantity: "200 gm piece",
        },
        {
          name: "8",
          value: "230",
          quantity: "200 gm piece",
        },
      ],
    },
    {
      id: 15,
      name: "Gomutra Neem Phenol",
      category: "environment",
      imageUrl1: GomutraNeemPhenolImg,
      images: [
        {
          imageUrl: GomutraNeemPhenolImg,
          alt: "Gomutra Neem Phenol",
        },
        {
          imageUrl: GomutraNeemPhenolImg,
          alt: "Gomutra Neem Phenol",
        },
        {
          imageUrl: GomutraNeemPhenolImg,
          alt: "Gomutra Neem Phenol",
        },
      ],
      price: [
        {
          name: "6",
          value: "30",
          quantity: "100 gm piece",
        },
        {
          name: "7",
          value: "50",
          quantity: "200 gm piece",
        },
        {
          name: "8",
          value: "230",
          quantity: "200 gm piece",
        },
      ],
    },

    //Grocery Category

    //Cereals Category
    {
      id: 16,
      name: "Brown Rice",
      category: "grocery-cereals",
      imageUrl1: BrownRiceImg1,
      imageUrl2: BrownRiceImg2,
      images: [
        {
          imageUrl: BrownRiceImg1,
          alt: "Brown Rice",
        },
        {
          imageUrl: BrownRiceImg2,
          alt: "Brown Rice",
        },
        {
          imageUrl: BrownRiceImg2,
          alt: "Brown Rice",
        },
      ],
      price: [
        {
          name: "9",
          value: "2,000",
          quantity: "1 kg",
        },
        {
          name: "9",
          value: "4,000",
          quantity: "5 kg",
        },
      ],
    },
    {
      id: 17,
      name: "White Rice",
      category: "grocery-cereals",
      imageUrl1: WhiteRiceImg1,
      imageUrl2: WhiteRiceImg2,
      images: [
        {
          imageUrl: WhiteRiceImg1,
          alt: "White Rice",
        },
        {
          imageUrl: WhiteRiceImg2,
          alt: "White Rice",
        },
        {
          imageUrl: WhiteRiceImg2,
          alt: "White Rice",
        },
      ],
      price: [
        {
          name: "9",
          value: "2,000",
          quantity: "1 kg",
        },
        {
          name: "9",
          value: "4,000",
          quantity: "5 kg",
        },
      ],
    },
    {
      id: 18,
      name: "Red Rice",
      category: "grocery-cereals",
      imageUrl1: RedRiceImg1,
      imageUrl2: RedRiceImg2,
      images: [
        {
          imageUrl: RedRiceImg1,
          alt: "Red Rice",
        },
        {
          imageUrl: RedRiceImg2,
          alt: "Red Rice",
        },
        {
          imageUrl: RedRiceImg1,
          alt: "Red Rice",
        },
      ],
      price: [
        {
          name: "9",
          value: "2,000",
          quantity: "1 kg",
        },
        {
          name: "9",
          value: "4,000",
          quantity: "5 kg",
        },
      ],
    },
    {
      id: 19,
      name: "Wild Black Rice",
      category: "grocery-cereals",
      imageUrl1: WildBlackRiceImg1,
      imageUrl2: WildBlackRiceImg2,
      images: [
        {
          imageUrl: WildBlackRiceImg1,
          alt: "Wild Black Rice",
        },
        {
          imageUrl: WildBlackRiceImg2,
          alt: "Wild Black Rice",
        },
        {
          imageUrl: WildBlackRiceImg2,
          alt: "Wild Black Rice",
        },
      ],
      price: [
        {
          name: "9",
          value: "2,000",
          quantity: "1 kg",
        },
        {
          name: "9",
          value: "4,000",
          quantity: "5 kg",
        },
      ],
    },
    {
      id: 20,
      name: "Barley Pearl",
      category: "grocery-cereals",
      imageUrl1: BarleyPearlImg1,
      imageUrl2: BarleyPearlImg2,
      images: [
        {
          imageUrl: BarleyPearlImg1,
          alt: "Barley Pearl",
        },
        {
          imageUrl: BarleyPearlImg2,
          alt: "Barley Pearl",
        },
        {
          imageUrl: BarleyPearlImg2,
          alt: "Barley Pearl",
        },
      ],
      price: [
        {
          name: "9",
          value: "2,000",
          quantity: "1 kg",
        },
        {
          name: "9",
          value: "4,000",
          quantity: "5 kg",
        },
      ],
    },
    {
      id: 21,
      name: "Barley Flake",
      category: "grocery-cereals",
      imageUrl1: BarleyFlakeImg1,
      imageUrl2: BarleyFlakeImg2,
      images: [
        {
          imageUrl: BarleyFlakeImg1,
          alt: "Barley Flake",
        },
        {
          imageUrl: BarleyFlakeImg2,
          alt: "Barley Flake",
        },
        {
          imageUrl: BarleyFlakeImg2,
          alt: "Barley Flake",
        },
      ],
      price: [
        {
          name: "9",
          value: "2,000",
          quantity: "1 kg",
        },
        {
          name: "9",
          value: "4,000",
          quantity: "5 kg",
        },
      ],
    },

    //Ghee Category
    {
      id: 22,
      name: "Ghee",
      category: "grocery-ghee",
      imageUrl1: GheeImg1,
      imageUrl2: GheeImg2,
      images: [
        {
          imageUrl: GheeImg1,
          alt: "Ghee",
        },
        {
          imageUrl: GheeImg2,
          alt: "Ghee",
        },
        {
          imageUrl: GheeImg2,
          alt: "Ghee",
        },
      ],
      price: [
        {
          name: "9",
          value: "2,000 ",
          quantity: "500 gm",
        },
        {
          name: "10",
          value: "3,800 ",
          quantity: "1 kg",
        },
      ],
    },

    // Honery & Jaggery Category
    {
      id: 23,
      name: "Honey",
      category: "grocery-honeyJaggery",
      imageUrl1: HoneyImg1,
      imageUrl2: HoneyImg2,
      images: [
        {
          imageUrl: HoneyImg1,
          alt: "Honey",
        },
        {
          imageUrl: HoneyImg2,
          alt: "Honey",
        },
        {
          imageUrl: HoneyImg2,
          alt: "Honey",
        },
      ],
      price: [
        {
          name: "11",
          value: "3,000",
          quantity: "500 gm",
        },
        {
          name: "12",
          value: "5,700",
          quantity: "1 kg",
        },
      ],
    },

    // Masala Category
    {
      id: 24,
      name: "Curry Leaf Powder",
      category: "grocery-masala",
      imageUrl1: CurryLeafPowderImg,
      images: [
        {
          imageUrl: CurryLeafPowderImg,
          alt: "Curry Leaf Powder",
        },
        {
          imageUrl: CurryLeafPowderImg,
          alt: "Curry Leaf Powder",
        },
        {
          imageUrl: CurryLeafPowderImg,
          alt: "HonCurry Leaf Powderey",
        },
      ],
      price: [
        {
          name: "13",
          value: "3,500",
          quantity: "500 gm",
        },
        {
          name: "14",
          value: "6,600",
          quantity: "1 kg",
        },
      ],
    },
    {
      id: 25,
      name: "Rasam Powder",
      category: "grocery-masala",
      imageUrl1: RasamPowderImg1,
      imageUrl2: RasamPowderImg2,
      images: [
        {
          imageUrl: RasamPowderImg1,
          alt: "Rasam Powder",
        },
        {
          imageUrl: RasamPowderImg2,
          alt: "Rasam Powder",
        },
        {
          imageUrl: RasamPowderImg2,
          alt: "Rasam Powderey",
        },
      ],
      price: [
        {
          name: "15",
          value: "3,500",
          quantity: "500 gm",
        },
        {
          name: "16",
          value: "6,600",
          quantity: "1 kg",
        },
      ],
    },

    //Misc Category
    {
      id: 26,
      name: "Edible Rose Water",
      category: "grocery-misc",
      imageUrl1: EdibleRoseWaterImg,
      images: [
        {
          imageUrl: EdibleRoseWaterImg,
          alt: "Edible Rose Water",
        },
        {
          imageUrl: EdibleRoseWaterImg,
          alt: "Edible Rose Water",
        },
        {
          imageUrl: EdibleRoseWaterImg,
          alt: "Edible Rose Water",
        },
      ],
      price: [
        {
          name: "17",
          value: "550",
          quantity: "500 gm",
        },
        {
          name: "18",
          value: "1050",
          quantity: "1 kg",
        },
      ],
    },

    // Oils Category
    {
      id: 27,
      name: "Ghani Oil",
      category: "grocery-oils",
      imageUrl1: GhaniOilImg,
      images: [
        {
          imageUrl: GhaniOilImg,
          alt: "Ghani Oil",
        },
        {
          imageUrl: GhaniOilImg,
          alt: "Ghani Oil",
        },
        {
          imageUrl: GhaniOilImg,
          alt: "Ghani Oil",
        },
      ],
      price: [
        {
          name: "19",
          value: "320",
          quantity: "100 gm",
        },
      ],
    },
    {
      id: 28,
      name: "Cocounut Oil",
      category: "grocery-oils",
      imageUrl1: CoconutOilImg1,
      imageUrl2: CoconutOilImg2,
      images: [
        {
          imageUrl: CoconutOilImg1,
          alt: "Cocounut Oil",
        },
        {
          imageUrl: CoconutOilImg2,
          alt: "Cocounut Oil",
        },
        {
          imageUrl: CoconutOilImg2,
          alt: "Cocounut Oil",
        },
      ],
      price: [
        {
          name: "19",
          value: "320",
          quantity: "100 gm",
        },
      ],
    },
    {
      id: 29,
      name: "Castor Oil",
      category: "grocery-oils",
      imageUrl1: CastorOilImg,
      images: [
        {
          imageUrl: CastorOilImg,
          alt: "Castor Oil",
        },
        {
          imageUrl: CastorOilImg,
          alt: "Castor Oil",
        },
        {
          imageUrl: CastorOilImg,
          alt: "Castor Oil",
        },
      ],
      price: [
        {
          name: "19",
          value: "320",
          quantity: "100 gm",
        },
      ],
    },

    // Pulses Category
    {
      id: 30,
      name: "Masoor",
      category: "grocery-pulses",
      imageUrl1: MasoorImg,
      images: [
        {
          imageUrl: MasoorImg,
          alt: "Masoor",
        },
        {
          imageUrl: MasoorImg,
          alt: "Masoor",
        },
        {
          imageUrl: MasoorImg,
          alt: "Masoor",
        },
      ],
      price: [
        {
          name: "15",
          value: "3,500",
          quantity: "500 gm",
        },
        {
          name: "16",
          value: "6,600",
          quantity: "1 kg",
        },
      ],
    },
    {
      id: 31,
      name: "Arhar",
      category: "grocery-pulses",
      imageUrl1: ArharImg,
      images: [
        {
          imageUrl: ArharImg,
          alt: "Arhar",
        },
        {
          imageUrl: ArharImg,
          alt: "Arhar",
        },
        {
          imageUrl: ArharImg,
          alt: "Arhar",
        },
      ],
      price: [
        {
          name: "15",
          value: "3,500",
          quantity: "500 gm",
        },
        {
          name: "16",
          value: "6,600",
          quantity: "1 kg",
        },
      ],
    },
    {
      id: 32,
      name: "Sabit Masoor Peeled",
      category: "grocery-pulses",
      imageUrl1: SabitMasoorPeeledImg,
      images: [
        {
          imageUrl: SabitMasoorPeeledImg,
          alt: "Sabit Masoor Peeled",
        },
        {
          imageUrl: SabitMasoorPeeledImg,
          alt: "Sabit Masoor Peeled",
        },
        {
          imageUrl: SabitMasoorPeeledImg,
          alt: "Sabit Masoor Peeled",
        },
      ],
      price: [
        {
          name: "15",
          value: "3,500",
          quantity: "500 gm",
        },
        {
          name: "16",
          value: "6,600",
          quantity: "1 kg",
        },
      ],
    },
    {
      id: 33,
      name: "Sabit Masoor",
      category: "grocery-pulses",
      imageUrl1: SabitMasoorImg,
      images: [
        {
          imageUrl: SabitMasoorImg,
          alt: "Sabit Masoor",
        },
        {
          imageUrl: SabitMasoorImg,
          alt: "Sabit Masoor",
        },
        {
          imageUrl: SabitMasoorImg,
          alt: "Sabit Masoor",
        },
      ],
      price: [
        {
          name: "15",
          value: "3,500",
          quantity: "500 gm",
        },
        {
          name: "16",
          value: "6,600",
          quantity: "1 kg",
        },
      ],
    },
    {
      id: 34,
      name: "Kabuli Chana",
      category: "grocery-pulses",
      imageUrl1: KabuliChanaImg,
      images: [
        {
          imageUrl: KabuliChanaImg,
          alt: "Kabuli Chana",
        },
        {
          imageUrl: KabuliChanaImg,
          alt: "Kabuli Chana",
        },
        {
          imageUrl: KabuliChanaImg,
          alt: "Kabuli Chana",
        },
      ],
      price: [
        {
          name: "15",
          value: "3,500",
          quantity: "500 gm",
        },
        {
          name: "16",
          value: "6,600",
          quantity: "1 kg",
        },
      ],
    },
    {
      id: 35,
      name: "Matar",
      category: "grocery-pulses",
      imageUrl1: MatarImg,
      images: [
        {
          imageUrl: MatarImg,
          alt: "Matar",
        },
        {
          imageUrl: MatarImg,
          alt: "Matar",
        },
        {
          imageUrl: MatarImg,
          alt: "Matar",
        },
      ],
      price: [
        {
          name: "15",
          value: "3,500",
          quantity: "500 gm",
        },
        {
          name: "16",
          value: "6,600",
          quantity: "1 kg",
        },
      ],
    },
    {
      id: 36,
      name: "Chana",
      category: "grocery-pulses",
      imageUrl1: ChanaImg,
      images: [
        {
          imageUrl: ChanaImg,
          alt: "Chana",
        },
        {
          imageUrl: ChanaImg,
          alt: "Chana",
        },
        {
          imageUrl: ChanaImg,
          alt: "Chana",
        },
      ],
      price: [
        {
          name: "15",
          value: "3,500",
          quantity: "500 gm",
        },
        {
          name: "16",
          value: "6,600",
          quantity: "1 kg",
        },
      ],
    },
    {
      id: 37,
      name: "Moong",
      category: "grocery-pulses",
      imageUrl1: MoongImg,
      images: [
        {
          imageUrl: MoongImg,
          alt: "Moong",
        },
        {
          imageUrl: MoongImg,
          alt: "Moong",
        },
        {
          imageUrl: MoongImg,
          alt: "Moong",
        },
      ],
      price: [
        {
          name: "15",
          value: "3,500",
          quantity: "500 gm",
        },
        {
          name: "16",
          value: "6,600",
          quantity: "1 kg",
        },
      ],
    },

    // Health Category
    {
      id: 38,
      name: "Kapila Gau Arka",
      category: "health",
      imageUrl1: KapilaGauArkaImg1,
      imageUrl2: KapilaGauArkaImg2,
      images: [
        {
          imageUrl: KapilaGauArkaImg1,
          alt: "Kapila Gau Arka",
        },
        {
          imageUrl: KapilaGauArkaImg2,
          alt: "Kapila Gau Arka",
        },
        {
          imageUrl: KapilaGauArkaImg2,
          alt: "Kapila Gau Arka",
        },
      ],
      price: [
        {
          name: "19",
          value: "320",
          quantity: "100 gm",
        },
      ],
    },
    {
      id: 39,
      name: "Muscle Oil",
      category: "health",
      imageUrl1: MuscleOilImg,
      images: [
        {
          imageUrl: MuscleOilImg,
          alt: "Muscle Oil",
        },
        {
          imageUrl: MuscleOilImg,
          alt: "Muscle Oil",
        },
        {
          imageUrl: MuscleOilImg,
          alt: "Muscle Oil",
        },
      ],
      price: [
        {
          name: "20",
          value: "160",
          quantity: "200 ml",
        },
        {
          name: "21",
          value: "350",
          quantity: "500 ml",
        },
        {
          name: "22",
          value: "650",
          quantity: "1 L",
        },
      ],
    },
    {
      id: 40,
      name: "Baby Massage Oil",
      category: "health",
      imageUrl1: BabyMassageOilImg,
      images: [
        {
          imageUrl: BabyMassageOilImg,
          alt: "Baby Massage Oil",
        },
        {
          imageUrl: BabyMassageOilImg,
          alt: "Baby Massage Oil",
        },
        {
          imageUrl: BabyMassageOilImg,
          alt: "Baby Massage Oil",
        },
      ],
      price: [
        {
          name: "23",
          value: "500",
          quantity: "1 L",
        },
        {
          name: "24",
          value: "2,000",
          quantity: "5 L",
        },
      ],
    },
    {
      id: 41,
      name: "Tulsi Arka",
      category: "health",
      imageUrl1: TulsiArkImg,
      images: [
        {
          imageUrl: TulsiArkImg,
          alt: "Tulsi Arka",
        },
        {
          imageUrl: TulsiArkImg,
          alt: "Tulsi Arka",
        },
        {
          imageUrl: TulsiArkImg,
          alt: "Tulsi Arka",
        },
      ],
      price: [
        {
          name: "25",
          value: "1,800",
          quantity: "5 kg pack",
        },
        {
          name: "26",
          value: "6,800",
          quantity: "20 kg pack",
        },
      ],
    },
    {
      id: 42,
      name: "Diabetes Arka",
      category: "health",
      imageUrl1: DiabetesArkImg1,
      imageUrl2: DiabetesArkImg2,
      images: [
        {
          imageUrl: DiabetesArkImg1,
          alt: "Diabetes Arka",
        },
        {
          imageUrl: DiabetesArkImg2,
          alt: "Diabetes Arka",
        },
        {
          imageUrl: DiabetesArkImg2,
          alt: "Diabetes Arka",
        },
      ],
      price: [
        {
          name: "25",
          value: "1,800",
          quantity: "5 kg pack",
        },
        {
          name: "26",
          value: "6,800",
          quantity: "20 kg pack",
        },
      ],
    },
    {
      id: 43,
      name: "Blood Pressure Arka",
      category: "health",
      imageUrl1: BloodPressureArkImg1,
      imageUrl2: BloodPressureArkImg2,
      images: [
        {
          imageUrl: BloodPressureArkImg1,
          alt: "Blood Pressure Arka",
        },
        {
          imageUrl: BloodPressureArkImg2,
          alt: "Blood Pressure Arka",
        },
        {
          imageUrl: BloodPressureArkImg2,
          alt: "Blood Pressure Arka",
        },
      ],
      price: [
        {
          name: "25",
          value: "1,800",
          quantity: "5 kg pack",
        },
        {
          name: "26",
          value: "6,800",
          quantity: "20 kg pack",
        },
      ],
    },
    {
      id: 44,
      name: "Cow Colostrum",
      category: "health",
      imageUrl1: CowColostrumImg,
      images: [
        {
          imageUrl: CowColostrumImg,
          alt: "Cow Colostrum",
        },
        {
          imageUrl: CowColostrumImg,
          alt: "Cow Colostrum",
        },
        {
          imageUrl: CowColostrumImg,
          alt: "Cow Colostrum",
        },
      ],
      price: [
        {
          name: "25",
          value: "1,800",
          quantity: "5 kg pack",
        },
        {
          name: "26",
          value: "6,800",
          quantity: "20 kg pack",
        },
      ],
    },
    {
      id: 45,
      name: "Wildcrafted Chyawanprash",
      category: "health",
      imageUrl1: WildcraftedChawanprashImg,
      images: [
        {
          imageUrl: WildcraftedChawanprashImg,
          alt: "Wildcrafted Chyawanprash",
        },
        {
          imageUrl: WildcraftedChawanprashImg,
          alt: "Wildcrafted Chyawanprash",
        },
        {
          imageUrl: WildcraftedChawanprashImg,
          alt: "Wildcrafted Chyawanprash",
        },
      ],
      price: [
        {
          name: "25",
          value: "1,800",
          quantity: "5 kg pack",
        },
        {
          name: "26",
          value: "6,800",
          quantity: "20 kg pack",
        },
      ],
    },
  ],

  gauSevak: [
    {
      name: "Kanjenkat Krishnan Jayan",
      imageUrl: Gausevak_Img1,
      designation: "Entreprenaur",
      about:
        "Jayan is a proud Goadharik jaiva krishi - 'Cow Protector Organic Farmer'.  He has a varied career, spending 30 years in West Asia, mainly in Dubai.  When he moved back to his hometown in Punnayarkulam, Kerala, he was moved by the challenges of how, over the years, it has become difficult to obtain naturally farmed agro products.  He noted the growing absence of compassion in agricultural practises was not merely a coincidence but the two were interlinked.  That is where began his new journey - he established the NGO Samskrithi Goshala to realize his goals of - compassionate farming, circular farming.He has formalized knowledge of farming, processing and packaging from not only his own family but from the villages around and combined it with technology solutions to build a sustainable model.  Bulls, cows and calves are cared for so much that they like staying there as much as he likes having them around!  He is an ardent supporter of a return to breeding of desi breeds - an incalculable civilization heritage.  He has rescued many from slaughter with the ecosystem he has built.  His efforts bring health to people who sample his agro produce.",
      social: {
        facebook: "https://www.facebook.com/amit.agarwal.1426",
        instagram: "https://www.facebook.com/amit.agarwal.1426",
        linkedin: "https://www.instagram.com/in/amit-agarwal-635a548",
      },
    },
    {
      name: "Krishnalal K J Prajapati",
      imageUrl: Gausevak_Img2,
      designation: "Web Developer",
      about:
        "Krishanlal is a B.S.c in in Math.  He is patient, dedicated and an aspiring farmopreneur, following his father's footsteps in making things better, both for Govansh and people. He interests are many, and diverse, but all marshalled into building a solid reputation for the organic farming-cum-cow shelter than his father established.  He is responsible for engineering designs and calculations needed to optimize various functions at Samskrithi Goshala.  He also leads the budding IT efforts with a view to link with the world and offer the very best of their delectable organic farm produce.",
      social: {
        facebook: "https://www.facebook.com/krishnalal.prajapati.7",
        instagram: "https://www.facebook.com/amit.agarwal.1426",
        linkedin: "",
      },
    },
  ],
};

export default WebData;
